/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmSpisovyUzel extends GContentBase<SeznamAdmSpisovyUzelObj> {
        private seznamObj: SeznamAdmSpisovyUzelObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmSpisovyUzelObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmSpisovyUzel",
                contentCaption: "jres:33000091",
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_su}"
                },
                gridSettings: {
                    columnOrder: "ixs_su,zkratka,nazev,poznamka,dat_zmena,zmenu_prov_txt,ofic_nazev,lic_adr,mail,url,tel,fax,ixs_nad_txt,ixs_fun_txt,priz_pod,priz_vyp,priz_kur,priz_evy,z_int,priz_prut,priz_servis"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmSpisovyUzelObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmSpisovyUzel", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmSpisovyUzel",
                newRecord: isNew,
                ixs_su: isNew == true ? null : data.ixs_su
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSeznamAdmDenikSslSpisovyUzel: {
                    icon: "fa-link",
                    caption: "jres:33000910", //RC 33000910 : P�i�azen� den�ky SSL
                    run: (ev, ctx) => {
                        this.openSeznamAdmDenikSslSpisovyUzel();
                    }
                },
                actOpenSeznamAdmSpisovyUzelProPredavani: {
                    icon: "fa-link",
                    caption: "jres:33000914", //RC 33000914 : Spisov� uzly pro p�ed�v�n�
                    run: (ev, ctx) => {
                        this.openSeznamAdmSpisovyUzelProPredavani();
                    }
                },
                actOpenHromadnaOperaceAdmDenikSslSpisovyUzel: {
                    caption: "jres:33000912", //RC 33000912 : P�i�adit hromadn� podac� den�ky
                    icon: "fa-link",
                    run: () => {
                        this.openHromadnaOperaceAdmDenikSslSpisovyUzel();
                    }
                },
                actOpenHromadnaOperaceAdmSpisovyUzelProPredavani: {
                    caption: "jres:33000920", //RC 33000920 : Hromadn� p�i�adit spis. uzly pro p�ed�n�
                    icon: "fa-link",
                    run: () => {
                        this.openHromadnaOperaceAdmSpisovyUzelProPredavani();
                    }
                },
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*", {
                    favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                        { action: this.cnt.actions.actOpenSeznamAdmDenikSslSpisovyUzel },
                        { action: this.cnt.actions.actOpenSeznamAdmSpisovyUzelProPredavani }
                    ],
                },
                {
                    favorite: true, type: "static", caption: "jres:33000628", icon: "fa-link", children: [ //RC 33000628 : Hromadn� operace
                        { action: this.cnt.actions.actOpenHromadnaOperaceAdmDenikSslSpisovyUzel },
                        { action: this.cnt.actions.actOpenHromadnaOperaceAdmSpisovyUzelProPredavani }
                    ]
                }
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDialogVyberovaSkupina*",
                "-",
                "actOpenSeznamAdmDenikSslSpisovyUzel*",
                "actOpenSeznamAdmSpisovyUzelProPredavani*",
                "-",
                "actOpenHromadnaOperaceAdmDenikSslSpisovyUzel*",
                "actOpenHromadnaOperaceAdmSpisovyUzelProPredavani*"
            ])
        }

        createFilterForm() {

        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmSpisovyUzel.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actOpenSeznamAdmDenikSslSpisovyUzel?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenSeznamAdmSpisovyUzelProPredavani?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenHromadnaOperaceAdmDenikSslSpisovyUzel?.update({ enabled: objArr.count > 0 })
            this.cnt.actions.actOpenHromadnaOperaceAdmSpisovyUzelProPredavani?.update({ enabled: objArr.count > 0 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.ixs_su),
                nazev: `${data.nazev}`
            }
        }

        private openSeznamAdmDenikSslSpisovyUzel() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmDenikSslSpisovyUzel", { ixs_su: activeRow.ixs_su })
        }

        private openSeznamAdmSpisovyUzelProPredavani() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmSpisovyUzelProPredavani", { ixs_su: activeRow.ixs_su })
        }

        private openHromadnaOperaceAdmDenikSslSpisovyUzel() {
            var selection = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmDenikSslSpisovyUzelReadDto[] = [];
            if (selection.length > 0) {
                selection.forEach((item) => {
                    data.push({
                        ixs_su: item["ixs_su"]
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceAdmDenikSslSpisovyUzel", { openFromSpisUzel: true }], { ID: "HromadnaOperaceAdmDenikSslSpisovyUzel", data: data }, "", 700, 500)
        }

        private openHromadnaOperaceAdmSpisovyUzelProPredavani() {
            var selection = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmSpisovyUzelProPredavaniReadDto[] = [];
            if (selection.length > 0) {
                selection.forEach((item) => {
                    data.push({
                        ixs_su: item["ixs_su"]
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceAdmSpisovyUzelProPredavani"], { ID: "HromadnaOperaceAdmSpisovyUzelProPredavani", data: data }, "", 700, 500)
        }
    }
}